import { useEffect, useId, useRef, useState } from "react";
import { drawScore, initialize } from "../../lib/vexflow";

// With fit, scale sets the notation size relative to its container: 0.75 matches the score page.
// `measureNumbers` numbers each row's first bar: true counts from 1, or a function of the index.
export default function RhythmPreview({ score, minWidth = 480, fit = false, compact = false, maxHeight, measureLabels, measureNumbers = false, hideTimeSignature = false, scale = 1 }) {
  const id = `practice-score-${useId().replace(/:/g, "")}`;
  const root = useRef(null);
  const [width, setWidth] = useState(680);
  const [error, setError] = useState(false);
  useEffect(() => {
    const observer = new ResizeObserver(([entry]) => setWidth(Math.max(minWidth, Math.floor((entry.contentRect.width - 50) / scale))));
    observer.observe(root.current);
    return () => observer.disconnect();
  }, [minWidth, scale]);
  useEffect(() => {
    const container = document.getElementById(id);
    if (!container || !score) return;
    container.innerHTML = "";
    try {
      const { renderer, context } = initialize(id);
      drawScore(renderer, context, score, null, () => {}, {
        width, scale: 1, hResize: 1, vResize: 1, justifyLastRow: true,
        measureNoteStartPadding: 4, measureNoteEndPadding: 8, minimumNoteSpacing: 22, measureLabels, hideTimeSignature, showMeasureNumbers: measureNumbers,
        // A small preview leaves out a bar's other takes; full notation shows the next as an ossia.
        takes: !compact,
      }, {});
      if (fit) {
        const svg = container.querySelector("svg");
        if (compact) {
          const bounds = svg.getBBox(), padding = 10;
          svg.setAttribute("viewBox",`${bounds.x-padding} ${bounds.y-padding} ${bounds.width+padding*2} ${bounds.height+padding*2}`);
          svg.setAttribute("width",bounds.width+padding*2);
          svg.setAttribute("height",bounds.height+padding*2);
        } else svg.setAttribute("viewBox",`0 0 ${svg.getAttribute("width")} ${svg.getAttribute("height")}`);
        svg.style.width = "100%";
        svg.style.height = "auto";
        if (maxHeight) svg.style.maxHeight = maxHeight;
        svg.style.display = "block";
      }
      setError(false);
    } catch { setError(true); }
    return () => { container.innerHTML = ""; };
  }, [score, width, id, fit, compact, maxHeight, measureLabels, measureNumbers, hideTimeSignature]);
  return <div ref={root} style={{ overflowX: fit ? "visible" : "auto", width: "100%", minWidth: 0 }}>
    <div id={id} aria-hidden="true" style={{ pointerEvents: "none" }} />
    {error && <span>Unable to display this rhythm.</span>}
  </div>;
}
